import { UnknownRoute, sendToSentry } from 'utils/errors'
import { FlowRoute } from 'utils/FlowProvider/types'

type PageViewEventFields = {
  object_name: string
  screen: string
  screen_name: string
  platform?: string
}

const laterOnboardingPageViewEvents = new Map<string, PageViewEventFields>([
  [
    FlowRoute.Welcome,
    {
      object_name: 'laterRegistrationInterstitial',
      screen: 'laterRegistrationInterstitial',
      screen_name: 'laterRegistrationInterstitial',
    },
  ],
  [
    FlowRoute.LaterSuitabilityQuestions,
    {
      object_name: 'laterRegistrationInvestorQuestions',
      screen: 'laterRegistrationInvestorQuestions',
      screen_name: 'laterRegistrationInvestorQuestions',
    },
  ],
  [
    FlowRoute.Analyzing,
    {
      object_name: 'laterRegistrationIRAInfoAnimation',
      screen: 'laterRegistrationIRAInfoAnimation',
      screen_name: 'laterRegistrationIRAInfoAnimation',
    },
  ],
  [
    FlowRoute.LaterIraRecommendation,
    {
      object_name: 'laterRegistrationIRARecommendation',
      screen: 'laterRegistrationIRARecommendation',
      screen_name: 'laterRegistrationIRARecommendation',
    },
  ],
  [
    FlowRoute.RecurringInvestment,
    {
      object_name: 'laterRegistrationRecurringInvestment',
      screen: 'laterRegistrationRecurringInvestment',
      screen_name: 'laterRegistrationRecurringInvestment',
    },
  ],
  [
    FlowRoute.OneTimeInvestment,
    {
      object_name: 'laterRegistrationOneTimeInvestment',
      screen: 'laterRegistrationOneTimeInvestment',
      screen_name: 'laterRegistrationOneTimeInvestment',
    },
  ],
  [
    FlowRoute.Institutions,
    {
      object_name: 'laterRegistrationLinkBankSearch',
      screen: 'laterRegistrationLinkBankSearch',
      screen_name: 'laterRegistrationLinkBankSearch',
    },
  ],
  // TODO: DBI
  [
    '/institution/link',
    {
      object_name: 'laterRegistrationLinkDirectBank',
      screen: 'laterRegistrationLinkDirectBank',
      screen_name: 'laterRegistrationLinkDirectBank',
    },
  ],
  [
    FlowRoute.ManualFundingSource,
    {
      object_name: 'laterRegistrationLinkBankManual',
      screen: 'laterRegistrationLinkBankManual',
      screen_name: 'laterRegistrationLinkBankManual',
    },
  ],
  [
    FlowRoute.MOCInterstitial,
    {
      object_name: 'mocRegistrationFunnelInterstitial',
      screen: 'mocRegistrationFunnelInterstitial',
      screen_name: 'mocRegistrationFunnelInterstitial',
    },
  ],
  [
    FlowRoute.MOCProgressStepOne,
    {
      object_name: 'registrationMOCProgressStepOne',
      screen: 'registrationMOCProgressStepOne',
      screen_name: 'registrationMOCProgressStepOne',
    },
  ],
  [
    FlowRoute.MOCProgressStepTwo,
    {
      object_name: 'registrationMOCProgressStepTwo',
      screen: 'registrationMOCProgressStepTwo',
      screen_name: 'registrationMOCProgressStepTwo',
    },
  ],
  [
    FlowRoute.MOCProgressStepThree,
    {
      object_name: 'registrationMOCProgressStepThree',
      screen: 'registrationMOCProgressStepThree',
      screen_name: 'registrationMOCProgressStepThree',
    },
  ],
  [
    FlowRoute.MOCReferralReminder,
    {
      object_name: 'registrationMOCReferralReminder',
      screen: 'registrationMOCReferralReminder',
      screen_name: 'registrationMOCReferralReminder',
    },
  ],
  [
    FlowRoute.MOCSuccess,
    {
      object_name: 'MOCSuccessScreenViewed',
      screen: 'MOCSuccessScreenViewed',
      screen_name: 'MOCSuccessScreenViewed',
    },
  ],
  [
    FlowRoute.MFASetup,
    {
      object_name: 'twoFactorAuthEnterCode',
      screen: 'twoFactorAuthEnterCode',
      screen_name: 'twoFactorAuthEnterCode',
    },
  ],
  [
    FlowRoute.PricingInterstitial,
    {
      object_name: 'registrationChooseSubscription',
      screen: 'registrationChooseSubscription',
      screen_name: 'registrationChooseSubscription',
    },
  ],
  [
    FlowRoute.BankLinkSuccess,
    {
      object_name: 'laterRegistrationLinkBankAccountLinked',
      screen: 'laterRegistrationLinkBankAccountLinked',
      screen_name: 'laterRegistrationLinkBankAccountLinked',
    },
  ],
  [
    FlowRoute.Success,
    {
      object_name: 'laterRegistrationCongratulations',
      screen: 'laterRegistrationComplete',
      screen_name: 'laterRegistrationComplete',
    },
  ],
])

const defaultPageViewEvents = new Map<string, PageViewEventFields>([
  [
    FlowRoute.Welcome,
    {
      object_name: 'registrationCreateAccount',
      screen: 'registrationCreateAccount',
      screen_name: 'registrationCreateAccount',
    },
  ],
  [
    FlowRoute.Analyzing,
    {
      object_name: 'registrationPortfolioAnimation',
      screen: 'registrationPortfolioAnimation',
      screen_name: 'registrationPortfolioAnimation',
    },
  ],
  [
    FlowRoute.BankLinkSuccess,
    {
      object_name: 'registrationLinkBankAccountLinked',
      screen: 'registrationLinkBankAccountLinked',
      screen_name: 'registrationLinkBankAccountLinked',
    },
  ],
  [
    FlowRoute.ChooseFundingSource,
    {
      object_name: 'registrationLinkBankSelectChecking',
      screen: 'registrationLinkBankSelectChecking',
      screen_name: 'registrationLinkBankSelectChecking',
    },
  ],
  [
    FlowRoute.ContactInfo,
    {
      object_name: 'registrationInformationContact',
      screen: 'registrationInformationContact',
      screen_name: 'registrationInformationContact',
    },
  ],
  [
    FlowRoute.Funding,
    {
      object_name: 'registrationLinkBankInterstitial',
      screen: 'registrationLinkBankInterstitial',
      screen_name: 'registrationLinkBankInterstitial',
    },
  ],
  [
    FlowRoute.Institutions,
    {
      object_name: 'registrationLinkBankSearch',
      screen: 'registrationLinkBankSearch',
      screen_name: 'registrationLinkBankSearch',
    },
  ],
  // TODO: DBI
  [
    '/institution/link',
    {
      object_name: 'registrationLinkDirectBank',
      screen: 'registrationLinkDirectBank',
      screen_name: 'registrationLinkDirectBank',
    },
  ],
  [
    FlowRoute.InvestInterstitial,
    {
      object_name: 'registrationInvestInterstitial',
      screen: 'registrationInvestInterstitial',
      screen_name: 'registrationInvestInterstitial',
    },
  ],
  [
    FlowRoute.InvestorQuestions,
    {
      object_name: 'registrationInformationInvestorQuestions',
      screen: 'registrationInformationInvestorQuestions',
      screen_name: 'registrationInformationInvestorQuestions',
    },
  ],
  [
    FlowRoute.LaterSuitabilityQuestions,
    {
      object_name: 'registrationPortfolioQuestionsPartOne',
      screen: 'registrationPortfolioQuestionsPartOne',
      screen_name: 'registrationPortfolioQuestionsPartOne',
    },
  ],
  [
    FlowRoute.ManualFundingSource,
    {
      object_name: 'registrationLinkBankManual',
      screen: 'registrationLinkBankManual',
      screen_name: 'registrationLinkBankManual',
    },
  ],
  [
    FlowRoute.MOCInterstitial,
    {
      object_name: 'mocRegistrationFunnelInterstitial',
      screen: 'mocRegistrationFunnelInterstitial',
      screen_name: 'mocRegistrationFunnelInterstitial',
    },
  ],
  [
    FlowRoute.MOCProgressStepOne,
    {
      object_name: 'registrationMOCProgressStepOne',
      screen: 'registrationMOCProgressStepOne',
      screen_name: 'registrationMOCProgressStepOne',
    },
  ],
  [
    FlowRoute.MOCProgressStepTwo,
    {
      object_name: 'registrationMOCProgressStepTwo',
      screen: 'registrationMOCProgressStepTwo',
      screen_name: 'registrationMOCProgressStepTwo',
    },
  ],
  [
    FlowRoute.MOCProgressStepThree,
    {
      object_name: 'registrationMOCProgressStepThree',
      screen: 'registrationMOCProgressStepThree',
      screen_name: 'registrationMOCProgressStepThree',
    },
  ],
  [
    FlowRoute.MOCReferralReminder,
    {
      object_name: 'registrationMOCReferralReminder',
      screen: 'registrationMOCReferralReminder',
      screen_name: 'registrationMOCReferralReminder',
    },
  ],
  [
    FlowRoute.MOCSuccess,
    {
      object_name: 'MOCSuccessScreenViewed',
      screen: 'MOCSuccessScreenViewed',
      screen_name: 'MOCSuccessScreenViewed',
    },
  ],
  [
    FlowRoute.MFASetup,
    {
      object_name: 'twoFactorAuthEnterCode',
      screen: 'twoFactorAuthEnterCode',
      screen_name: 'twoFactorAuthEnterCode',
    },
  ],
  [
    FlowRoute.OneTimeInvestment,
    {
      object_name: 'registrationInitialInvestmentOneTime',
      screen: 'registrationInitialInvestmentOneTime',
      screen_name: 'registrationInitialInvestmentOneTime',
    },
  ],
  [
    FlowRoute.PersonalInfo,
    {
      object_name: 'registrationInformationPersonal',
      screen: 'registrationInformationPersonal',
      screen_name: 'registrationInformationPersonal',
    },
  ],
  [
    FlowRoute.PortfolioOverview,
    {
      object_name: 'registrationPortfolioBreakdown',
      screen: 'registrationPortfolioBreakdown',
      screen_name: 'registrationPortfolioBreakdown',
    },
  ],
  [
    FlowRoute.PreviewPortfolio,
    {
      object_name: 'registrationPreviewPortfolio',
      screen: 'registrationPreviewPortfolio',
      screen_name: 'registrationPreviewPortfolio',
    },
  ],
  [
    FlowRoute.SelectPortfolioTheme,
    {
      object_name: 'registrationSelectPortfolioTheme',
      screen: 'registrationSelectPortfolioTheme',
      screen_name: 'registrationSelectPortfolioTheme',
    },
  ],
  [
    FlowRoute.PricingInterstitial,
    {
      object_name: 'registrationChooseSubscription',
      screen: 'registrationChooseSubscription',
      screen_name: 'registrationChooseSubscription',
    },
  ],
  [
    FlowRoute.ESGEducationFlow,
    {
      object_name: 'registrationEsgEducationFlow',
      screen: 'registrationEsgEducationFlow',
      screen_name: 'registrationEsgEducationFlow',
    },
  ],
  [
    FlowRoute.RecurringInvestment,
    {
      object_name: 'registrationInitialInvestmentRecurring',
      screen: 'registrationInitialInvestmentRecurring',
      screen_name: 'registrationInitialInvestmentRecurring',
    },
  ],
  [
    FlowRoute.ReferralReward,
    {
      object_name: 'referralDisclosure',
      screen_name: 'referralDisclosure',
      screen: 'referralDisclosure',
    },
  ],
  [
    FlowRoute.RoundUpsInterstitial,
    {
      object_name: 'registrationRoundUpsInterstitial',
      screen_name: 'registrationRoundUpsInterstitial',
      screen: 'registrationRoundUpsInterstitial',
    },
  ],
  [
    FlowRoute.RoundUpsFunding,
    {
      object_name: 'registrationRoundUpsFunding',
      screen_name: 'registrationRoundUpsFunding',
      screen: 'registrationRoundUpsFunding',
    },
  ],
  [
    FlowRoute.RoundUpsPast,
    {
      object_name: 'registrationRoundUpsPast',
      screen_name: 'registrationRoundUpsPast',
      screen: 'registrationRoundUpsPast',
    },
  ],
  [
    FlowRoute.Signup,
    {
      object_name: 'registrationCreateAccount',
      screen: 'registrationCreateAccount',
      screen_name: 'registrationCreateAccount',
    },
  ],
  [
    FlowRoute.SecondChanceBankLink,
    {
      object_name: 'registrationSecondChanceLinkBankInterstitial',
      screen: 'registrationSecondChanceLinkBankInterstitial',
      screen_name: 'registrationSecondChanceLinkBankInterstitial',
    },
  ],
  [
    FlowRoute.SelectTier,
    {
      object_name: 'registrationSelectTier',
      screen: 'registrationSelectTier',
      screen_name: 'registrationSelectTier',
    },
  ],
  [
    FlowRoute.SSN,
    {
      object_name: 'registrationSsn',
      screen: 'registrationSsn',
      screen_name: 'registrationSsn',
    },
  ],
  [
    FlowRoute.Success,
    {
      object_name: 'registrationSuccess',
      screen: 'registrationSuccess',
      screen_name: 'registrationSuccess',
    },
  ],
  [
    FlowRoute.SuitabilityInterstitial,
    {
      object_name: 'registrationSuitabilityInterstitial',
      screen: 'registrationSuitabilityInterstitial',
      screen_name: 'registrationSuitabilityInterstitial',
    },
  ],
  [
    FlowRoute.PortfolioRecommendation,
    {
      object_name: 'registrationProductRecommendation',
      screen: 'registrationProductRecommendation',
      screen_name: 'registrationProductRecommendation',
    },
  ],
  [
    FlowRoute.SuitabilityQuestions,
    {
      object_name: 'registrationPortfolioQuestions',
      screen: 'registrationPortfolioQuestions',
      screen_name: 'registrationPortfolioQuestions',
    },
  ],
  [
    FlowRoute.RoundUpsInterstitial,
    {
      object_name: 'registrationRoundUpsInterstitial',
      screen_name: 'registrationRoundUpsInterstitial',
      screen: 'registrationRoundUpsInterstitial',
    },
  ],
  [
    FlowRoute.RoundUpsFunding,
    {
      object_name: 'registrationRoundUpsFunding',
      screen_name: 'registrationRoundUpsFunding',
      screen: 'registrationRoundUpsFunding',
    },
  ],
  [
    FlowRoute.RoundUpsPast,
    {
      object_name: 'registrationRoundUpsPast',
      screen_name: 'registrationRoundUpsPast',
      screen: 'registrationRoundUpsPast',
    },
  ],
])

const spendFunnelPageViewEvents = new Map<string, PageViewEventFields>([
  [
    FlowRoute.Welcome,
    {
      object_name: 'registrationSpendSpendIntro',
      screen: 'registrationSpendSpendIntro',
      screen_name: 'registrationSpendSpendIntro',
    },
  ],
  [
    FlowRoute.Signup,
    {
      object_name: 'registrationCreateAccount',
      screen: 'registrationCreateAccount',
      screen_name: 'registrationCreateAccount',
    },
  ],
  [
    FlowRoute.ContactInfo,
    {
      object_name: 'registrationInformationContact',
      screen: 'registrationInformationContact',
      screen_name: 'registrationInformationContact',
    },
  ],
  [
    FlowRoute.PersonalInfo,
    {
      object_name: 'registrationInformationPersonal',
      screen: 'registrationInformationPersonal',
      screen_name: 'registrationInformationPersonal',
    },
  ],
  [
    FlowRoute.Institutions,
    {
      object_name: 'registrationLinkBankSearch',
      screen: 'registrationLinkBankSearch',
      screen_name: 'registrationLinkBankSearch',
    },
  ],
  // TODO: DBI
  [
    '/institution/link',
    {
      object_name: 'registrationLinkDirectBank',
      screen: 'registrationLinkDirectBank',
      screen_name: 'registrationLinkDirectBank',
    },
  ],
  [
    FlowRoute.ManualFundingSource,
    {
      object_name: 'registrationLinkBankManual',
      screen: 'registrationLinkBankManual',
      screen_name: 'registrationLinkBankManual',
    },
  ],
  [
    FlowRoute.MOCInterstitial,
    {
      object_name: 'mocRegistrationFunnelInterstitial',
      screen: 'mocRegistrationFunnelInterstitial',
      screen_name: 'mocRegistrationFunnelInterstitial',
    },
  ],
  [
    FlowRoute.MOCProgressStepOne,
    {
      object_name: 'registrationMOCProgressStepOne',
      screen: 'registrationMOCProgressStepOne',
      screen_name: 'registrationMOCProgressStepOne',
    },
  ],
  [
    FlowRoute.MOCProgressStepTwo,
    {
      object_name: 'registrationMOCProgressStepTwo',
      screen: 'registrationMOCProgressStepTwo',
      screen_name: 'registrationMOCProgressStepTwo',
    },
  ],
  [
    FlowRoute.MOCProgressStepThree,
    {
      object_name: 'registrationMOCProgressStepThree',
      screen: 'registrationMOCProgressStepThree',
      screen_name: 'registrationMOCProgressStepThree',
    },
  ],
  [
    FlowRoute.MOCReferralReminder,
    {
      object_name: 'registrationMOCReferralReminder',
      screen: 'registrationMOCReferralReminder',
      screen_name: 'registrationMOCReferralReminder',
    },
  ],
  [
    FlowRoute.MOCSuccess,
    {
      object_name: 'MOCSuccessScreenViewed',
      screen: 'MOCSuccessScreenViewed',
      screen_name: 'MOCSuccessScreenViewed',
    },
  ],
  [
    FlowRoute.MFASetup,
    {
      object_name: 'twoFactorAuthEnterCode',
      screen: 'twoFactorAuthEnterCode',
      screen_name: 'twoFactorAuthEnterCode',
    },
  ],
  [
    FlowRoute.ChooseFundingSource,
    {
      object_name: 'registrationLinkBankSelectChecking',
      screen: 'registrationLinkBankSelectChecking',
      screen_name: 'registrationLinkBankSelectChecking',
    },
  ],
  [
    FlowRoute.Prefund,
    {
      object_name: 'registrationSpendSpendPrefund',
      screen: 'registrationSpendSpendPrefund',
      screen_name: 'registrationSpendSpendPrefund',
    },
  ],
  [
    FlowRoute.SignYourCard,
    {
      object_name: 'registrationSpendSpendCardSignature',
      screen: 'registrationSpendSpendCardSignature',
      screen_name: 'registrationSpendSpendCardSignature',
    },
  ],
  [
    FlowRoute.SpendOrderConfirmation,
    {
      object_name: 'registrationSpendSpendOrderConfirmation',
      screen: 'registrationSpendSpendOrderConfirmation',
      screen_name: 'registrationSpendSpendOrderConfirmation',
    },
  ],
  [
    FlowRoute.SpendCoreInterstitial,
    {
      object_name: 'registrationSpendSpendCoreInterstitial',
      screen: 'registrationSpendSpendCoreInterstitial',
      screen_name: 'registrationSpendSpendCoreInterstitial',
    },
  ],
  [
    FlowRoute.SuitabilityQuestions,
    {
      object_name: 'registrationPortfolioQuestions',
      screen: 'registrationPortfolioQuestions',
      screen_name: 'registrationPortfolioQuestions',
    },
  ],
  [
    FlowRoute.InvestorQuestions,
    {
      object_name: 'registrationInformationInvestorQuestions',
      screen: 'registrationInformationInvestorQuestions',
      screen_name: 'registrationInformationInvestorQuestions',
    },
  ],
  [
    FlowRoute.Analyzing,
    {
      object_name: 'registrationPortfolioAnimation',
      screen: 'registrationPortfolioAnimation',
      screen_name: 'registrationPortfolioAnimation',
    },
  ],
  [
    FlowRoute.PortfolioOverview,
    {
      object_name: 'registrationPortfolioBreakdown',
      screen: 'registrationPortfolioBreakdown',
      screen_name: 'registrationPortfolioBreakdown',
    },
  ],
  [
    FlowRoute.PreviewPortfolio,
    {
      object_name: 'registrationPreviewPortfolio',
      screen: 'registrationPreviewPortfolio',
      screen_name: 'registrationPreviewPortfolio',
    },
  ],
  [
    FlowRoute.PricingInterstitial,
    {
      object_name: 'registrationChooseSubscription',
      screen: 'registrationChooseSubscription',
      screen_name: 'registrationChooseSubscription',
    },
  ],
  [
    FlowRoute.RoundUpsInterstitial,
    {
      object_name: 'registrationRoundUpsInterstitial',
      screen_name: 'registrationRoundUpsInterstitial',
      screen: 'registrationRoundUpsInterstitial',
    },
  ],
  [
    FlowRoute.RoundUpsFunding,
    {
      object_name: 'registrationRoundUpsFunding',
      screen_name: 'registrationRoundUpsFunding',
      screen: 'registrationRoundUpsFunding',
    },
  ],
  [
    FlowRoute.RoundUpsPast,
    {
      object_name: 'registrationRoundUpsPast',
      screen_name: 'registrationRoundUpsPast',
      screen: 'registrationRoundUpsPast',
    },
  ],
  [
    FlowRoute.Success,
    {
      object_name: 'registrationSuccess',
      screen: 'registrationSuccess',
      screen_name: 'registrationSuccess',
    },
  ],
])

const directToMobileFunnelPageViewEvents = new Map<string, PageViewEventFields>([
  [
    FlowRoute.DirectToMobileLander,
    {
      object_name: 'directToMobile',
      screen: 'directToMobile',
      screen_name: 'directToMobile',
    },
  ],
])

// Given a location object, resolve to event metadata
export const getPageViewEvent = (location, flow) => {
  let eventData
  const pathname =
    location.pathname === FlowRoute.Welcome
      ? location.pathname
      : location.pathname.replace(/\/$/, '')
  switch (flow) {
    case 'laterOnboarding': {
      return (eventData = laterOnboardingPageViewEvents.get(pathname))
    }
    case 'spend': {
      return (eventData = spendFunnelPageViewEvents.get(pathname))
    }
    case 'directToMobile': {
      return (eventData = directToMobileFunnelPageViewEvents.get(pathname))
    }
    default: {
      eventData = defaultPageViewEvents.get(pathname)
    }
  }

  // If event data could not be resolved from the path, log it for follow up
  if (!eventData && process.env.BUILD_ENV !== 'production') {
    sendToSentry(new UnknownRoute('Unable to find page viewed event definition.'), {
      extras: { pathname: location.pathname },
    })
  }
  return eventData || {}
}
